import { LevelType } from 'data/types';

export function levelHasPartialDuctwork(level: LevelType): boolean {
  return (
    level.attributes.find((attribute) => attribute.code === 'level_ductwork')
      ?.value === 'Partial'
  );
}

export function structureHasPartialDuctworkLevel(
  structure: LevelType[]
): boolean {
  return structure.some((level) => levelHasPartialDuctwork(level));
}

export function levelHasFullDuctwork(level: LevelType): boolean {
  return (
    level.attributes.find((attribute) => attribute.code === 'level_ductwork')
      ?.value === 'Full'
  );
}

export function getFirstDuctworkToggleSpaceId(
  structure: LevelType[],
  activeLevelIndex: number
): string | undefined {
  const partialLevels = structure.filter(levelHasPartialDuctwork);
  const activeLevel = structure[activeLevelIndex];
  const orderedLevels =
    activeLevel && levelHasPartialDuctwork(activeLevel)
      ? [activeLevel, ...partialLevels.filter((level) => level !== activeLevel)]
      : partialLevels;
  return orderedLevels
    .flatMap((level) => level.sections.flatMap((section) => section.spaces))
    .at(0)?.uniqueId;
}
